module.exports = __webpack_public_path__ + "static/media/logo.1452e1c4.jpg";